import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import * as _moment from "moment";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";

import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatSortHeader,
  MatSort,
  MatDialog,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  Sort,
} from "@angular/material";
import { Router } from "@angular/router";
import { EmployeeService } from "../../shared/service/employee.service";
import { ToastrService } from "ngx-toastr";
import { EmployeeModel } from "../../shared/models/employee.model";
import { UserService } from "../../shared/service/user.service";
import * as xlsx from "xlsx";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { Excelfile } from "../../shared/models/Excelfile";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { DatePipe, formatDate, getLocaleDateFormat } from "@angular/common";
import { AppConfig } from "../../app.config";
import { format } from "url";
import { DepartmentsService } from "../../shared/service/departments.service";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { GroupIdConfirmDialogComponent } from "../../shared/components/group-id-confirm-dialog/group-id-confirm-dialog.component";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-hr-employee-list",
  templateUrl: "./hr-employee-list.component.html",
  styleUrls: ["./hr-employee-list.component.css"],
  // encapsulation: ViewEncapsulation.None,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HREmployeeListComponent implements OnInit {
  eeTypeList: any;
  result: any;
  error: string;
  isAddEmployee: boolean;
  permission: any;
  todayDate: Date;
  originalDataSourceAll: BasicEmployeeDetails[] = [];
  originalDataSourceFTE: EmployeeModel[] = [];
  originalDataSourceSubCon: EmployeeModel[] = [];
  datePipe: DatePipe;
  Date = new Date();
  statusResult: any;
  cadreResult: any;
  locationResult: any;
  geoResult: any;
  empTypeResult: any;
  totalItems: number;
  search: any;
  pageSizeOpt: string;
  pageSizeOptions = [];
  pageSize = 10;

  employeeDetails: BasicEmployeeDetails[];
  excelDetails: Excelfile[];
  isLoader: boolean = true;
  //Mat table attributes to get all employees list
  dataSourceAll: MatTableDataSource<BasicEmployeeDetails>;
  displayedColumns: string[] = [
    "EmpCode",
    "FirstName",
    "EmployeeStatus",
    "DesignationName",
    "LocationName",
    "DepartmentName",
    "CadreName",
    "DOJ",
    "DateOfExit",
  ];

  //Mat table attributes to get all active FTEs list
  dataSourceFTE: MatTableDataSource<EmployeeModel>;
  displayColumnsinFTE: string[] = [
    "EmpCode",
    "FirstName",
    "DesignationName",
    "LocationName",
    "DepartmentName",
    "CadreName",
    "DOJ",
    "DateOfExit",
  ];

  //Mat table attributes to get all active SubCon employees list
  dataSourceSubCon: MatTableDataSource<EmployeeModel>;
  displayColumnsinSubCon: string[] = [
    "EmpCode",
    "FirstName",
    "DesignationName",
    "LocationName",
    "DepartmentName",
    "CadreName",
    "DOJ",
    "DateOfExit",
  ];

  isOpen: boolean = false;
  selectedAllStatus = false;
  selectedAllEmpType = false;
  selectedAllLocations = false;
  selectedAllGeo = false;
  selectedAllCadres = false;
  locationsList: any;
  teamList: any;
  cadresList: any;
  lstData: any;
  statusList: any[] = [
    { value: "Active", name: "Active", checked: true, ID: 1, Value: "Active" },
    {
      value: "Resigned",
      name: "Resigned",
      checked: true,
      ID: 2,
      Value: "Resigned",
    },
    {
      value: "Relieved",
      name: "Relieved",
      checked: true,
      ID: 3,
      Value: "Relieved",
    },
    {
      value: "Deceased",
      name: "Deceased",
      checked: true,
      ID: 4,
      Value: "Deceased",
    },
  ];

  @ViewChild("paginatorAll", { static: true }) paginatorAll: MatPaginator;
  @ViewChild("sortAll", { static: true }) sortAll: MatSort;
  @ViewChild("select", { static: true }) select: MatSelect;
  @ViewChild("empType", { static: true }) empType: MatSelect;
  @ViewChild("location", { static: true }) location: MatSelect;
  @ViewChild("geo", { static: true }) geo: MatSelect;
  @ViewChild("cadre", { static: true }) cadre: MatSelect;
  @ViewChild("paginatorSubCon", { static: true }) paginatorSubCon: MatPaginator;
  @ViewChild("sortSubCon", { static: true }) sortSubCon: MatSort;
  @ViewChild("paginatorFTE", { static: true }) paginatorFTE: MatPaginator;
  @ViewChild("sortFTE", { static: true }) sortFTE: MatSort;

  constructor(
    private _service: EmployeeService,
    private onboardSvc: OnboardingService,
    private config: AppConfig,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private deptSvc: DepartmentsService,
    public _userService: UserService
  ) {
    this.todayDate = new Date();
    this.Date = new Date();
    this.Date.setHours(0,0,0,0)
    this.dataSourceFTE = new MatTableDataSource();
    this.dataSourceAll = new MatTableDataSource();
    this.dataSourceSubCon = new MatTableDataSource();
  }

  ngOnChanges() {
    this.getAllEmployees();
    //this.getExcelEmployees();
    this.getEeTypeList();
    this.getLocations();
  }

  ngOnInit() {
    this.getAllEmployees()
      .then(() => this.getTeamList())
      .then(() => this.getEeTypeList())
      .then(() => this.getLocations())
      .then(() => this.getCadres())
      .then(() => {
        this.initializeSelections();
      })
      .catch((err) => console.error("Error fetching data", err));
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    //this.isAddEmployee = hrMenu.AddingPermission || hrMenu.HasFullAccess;
  }

  filterBtnClick(val) {
    if (this.cadreResult && this.cadreResult.length === 0) {
      const preparedFinalList = this.prepareUnSelectResponse(
        this.cadresList,
        "CadreName"
      );
      this.cadresList = preparedFinalList || [];
    } else {
      const preparedFinalList = this.prepareResponseCustom(
        this.cadresList,
        "CadreName",
        this.cadreResult
      );
      this.cadresList = preparedFinalList || [];
    }

    if (this.geoResult && this.geoResult.length === 0) {
      const preparedFinalList = this.prepareUnSelectResponse(
        this.teamList,
        "Value"
      );
      this.teamList = preparedFinalList || [];
    } else {
      const preparedFinalList = this.prepareResponseCustom(
        this.teamList,
        "Value",
        this.geoResult
      );
      this.teamList = preparedFinalList || [];
    }

    if (this.locationResult && this.locationResult.length === 0) {
      const preparedFinalList = this.prepareUnSelectResponse(
        this.locationsList,
        "LocationName"
      );
      this.locationsList = preparedFinalList || [];
    } else {
      const preparedFinalList = this.prepareResponseCustom(
        this.locationsList,
        "LocationName",
        this.locationResult
      );
      this.locationsList = preparedFinalList || [];
    }

    if (this.empTypeResult && this.empTypeResult.length === 0) {
      const preparedFinalList = this.prepareUnSelectResponse(
        this.eeTypeList,
        "Value"
      );
      this.eeTypeList = preparedFinalList || [];
    } else {
      const preparedFinalList = this.prepareResponseCustom(
        this.eeTypeList,
        "Value",
        this.empTypeResult
      );
      this.eeTypeList = preparedFinalList || [];
    }

    if (this.statusResult && this.statusResult.length === 0) {
      const preparedFinalList = this.prepareUnSelectResponse(
        this.statusList,
        "Value"
      );
      this.statusList = preparedFinalList || [];
    } else {
      this.statusResult = this.statusResult || [];
      this.statusList = this.statusList.map((item) =>
        this.statusResult.includes(item.value)
          ? {
              ...item,
              checked: true,
            }
          : item
      );
    }
  }

  initializeSelections() {
    this.statusResult = this.statusList.map((status) => status.value);
    this.selectedAllStatus = true;
    this.empTypeResult = this.eeTypeList.map((status) => status.ID);
    this.selectedAllEmpType = true;
    this.locationResult = this.locationsList.map((status) => status.ID);
    this.selectedAllLocations = true;
    this.geoResult =
      this.teamList != null ? this.teamList.map((status) => status.ID) : null;
    this.selectedAllGeo = true;
    this.cadreResult = this.cadresList.map((status) => status.ID);
    this.selectedAllCadres = true;
    this.filterRecords();
  }

  shareCheckedList(item: any[], type) {
    if (type === "Status") {
      this.statusResult = item;
      this.filterRecords();
    }
  }

  shareIndividualCheckedList(item: {}) {
    this.filterRecords();
  }

  shareCheckedListFullObj(item: any[], type) {
    if (type === "EmpType") {
      this.empTypeResult = item.map(({ ID }) => ID);
    }
    if (type === "Location") {
      this.locationResult = item.map(({ ID }) => ID);
    }
    if (type === "Geo") {
      this.geoResult = item.map(({ ID }) => ID);
    }
    if (type === "Cadre") {
      this.cadreResult = item.map(({ ID }) => ID);
    }
    this.filterRecords();
  }

  onMouseLeave(event: MouseEvent): void {
    if (
      (event.relatedTarget as HTMLInputElement).className !==
        "cdk-overlay-backdrop cdk-overlay-transparent-backdrop-cs" &&
      (event.relatedTarget as HTMLInputElement).className !==
        "cdk-overlay-backdrop mat-overlay-transparent-backdrop"
    ) {
      this.isOpen = !this.isOpen;
    }
  }

  rowClick(row) {
    sessionStorage.setItem("mainHeaderSelectedTab", "Master");
    sessionStorage.setItem("mainHeaderUrl", "/hremployeelist");
    this.router.navigateByUrl("/hremployeedetails/" + row.EmpCode);
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  //applyFilter(filterValue: string) {
  //  if (filterValue != "" && filterValue != null) {
  //    var result = this.dataSourceAll.data;
  //    this.dataSourceAll = new MatTableDataSource(
  //      result.filter(
  //        (res) =>
  //          (res.FirstName != "" &&
  //            res.FirstName != null &&
  //            this.removeExtraSpaces(res.FirstName.toLowerCase()).includes(
  //              this.removeExtraSpaces(filterValue.toLowerCase())
  //            )) ||
  //          res.EmpCode.toString().includes(filterValue.toLowerCase())
  //      )
  //    );
  //  } else {
  //    this.filterRecords();
  //  }

  //  const data = [...this.dataSourceAll.data];
  //  this.dataSourceAll = new MatTableDataSource(this.sortList(data))
  //  this.totalItems = this.dataSourceAll.data.length;
  //  this.dataSourceAll.paginator = this.paginatorAll;
  //}
  applyFTEFilter(filterValue: string) {
    if (filterValue != "" && filterValue != null) {
      this.dataSourceFTE = new MatTableDataSource(
        this.originalDataSourceFTE.filter(
          (res) =>
            (res.FirstName != "" &&
              res.FirstName != null &&
              this.removeExtraSpaces(res.FirstName.toLowerCase()).includes(
                this.removeExtraSpaces(filterValue.toLowerCase())
              )) ||
            res.EmpCode.toString().includes(filterValue.toLowerCase())
        )
      );
    } else {
      this.dataSourceFTE = new MatTableDataSource(this.originalDataSourceFTE);
    }

    const data = [...this.dataSourceFTE.data];
    this.dataSourceFTE.paginator = this.paginatorFTE;
    this.dataSourceFTE.data = data.sort((a, b) => {
      // Compare empcode values in descending order
      if (a.EmpCode > b.EmpCode) {
        return -1;
      } else if (a.EmpCode < b.EmpCode) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  applySubConFilter(filterValue: string) {
    this.dataSourceSubCon.filter = filterValue.trim().toLowerCase();
    if (filterValue != "" && filterValue != null) {
      this.dataSourceSubCon = new MatTableDataSource(
        this.originalDataSourceSubCon.filter(
          (res) =>
            (res.FirstName != "" &&
              res.FirstName != null &&
              this.removeExtraSpaces(res.FirstName.toLowerCase()).includes(
                this.removeExtraSpaces(filterValue.toLowerCase())
              )) ||
            res.EmpCode.toString().includes(filterValue.toLowerCase())
        )
      );
    } else {
      this.dataSourceSubCon = new MatTableDataSource(
        this.originalDataSourceSubCon
      );
    }

    const data = [...this.dataSourceSubCon.data];
    this.dataSourceSubCon.paginator = this.paginatorSubCon;
    this.dataSourceSubCon.data = data.sort((a, b) => {
      // Compare empcode values in descending order
      if (a.EmpCode > b.EmpCode) {
        return -1;
      } else if (a.EmpCode < b.EmpCode) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  getAllEmployees() {
    this.isLoader = true;
    return this._service
      .getAllEmployees()
      .toPromise()
      .then(
        (data: BasicEmployeeDetails[]) => {
          this.employeeDetails = data || [];
          this.employeeDetails.forEach((employee) => {
            this.setEmpStatus(employee);
          });
          this.dataSourceAll.data = this.employeeDetails || [];
          this.originalDataSourceAll = this.employeeDetails || [];
          this.dataSourceAll.paginator = this.paginatorAll;
          this.dataSourceAll.sort = this.sortAll;
          var result = this.sortList(this.employeeDetails);
          this.dataSourceAll = new MatTableDataSource(result);
          this.totalItems = this.dataSourceAll.data.length;
          this.paginatorAll.pageSize = this.pageSize;
          this.dataSourceAll.paginator = this.paginatorAll;
          this.isLoader = false;
        },
        (error) => {
          this.error = error;
          this.isLoader = false;
        }
      );
  }

  setEmpStatus(HREmp) {
    var value = HREmp.IsMigratedOnH1 ? HREmp.US_DOE : HREmp.DateOfExit;
    if (HREmp.IsDeceased != true) {
      if (value == null) {
        HREmp.EmpStatus = "Active";
      } else if (
        value != null &&
        formatDate(value, "yyyy-MM-dd", "en_US") >=
          formatDate(new Date(), "yyyy-MM-dd", "en_US")
      ) {
        HREmp.EmpStatus = "Resigned";
      } else {
        HREmp.EmpStatus = "Relieved";
      }
    } else if (HREmp.IsDeceased) {
      HREmp.EmpStatus = "Deceased";
    }
  }

  sortList(list) {
    let results = [];
    if (list != null) {
      var data = list;
      if (data != undefined) {
        data = data.sort((a, b) => {
          return compare(a.EmpCode, b.EmpCode, true);
        });
        data.forEach((res) => results.push(res));
      }
    }
    this.lstData = results;
    return results;
  }

  sortData(sort: Sort): void {
    this.lstData = this.dataSourceAll.data;
    let data = this.lstData.slice();
    if (!sort.active || sort.direction == "") {
      this.dataSourceAll = new MatTableDataSource(data);
      this.paginatorAll.pageSize = this.pageSize;
      this.dataSourceAll.paginator = this.paginatorAll;
      return;
    }

    this.dataSourceAll = new MatTableDataSource(
      data.sort((a, b) => {
        let isdesc = sort.direction == "desc";
        switch (sort.active) {
          case "EmpCode":
            return compare(a.EmpCode, b.EmpCode, isdesc);
          case "FirstName":
            return compare(a.FirstName, b.FirstName, isdesc);
          case "DesignationName":
            return compare(a.DesignationName, b.DesignationName, isdesc);
          case "LocationName":
            return compare(a.LocationName, b.LocationName, isdesc);
          case "DepartmentName":
            return compare(a.Department, b.Department, isdesc);
          case "CadreName":
            return compare(a.CadreName, b.CadreName, isdesc);
          case "DOJ":
            return compare(a.DOJ, b.DOJ, isdesc);
          case "DateOfExit":
            return compare(
              a.IsMigratedOnH1 ? a.US_DOE : a.DateOfExit,
              b.IsMigratedOnH1 ? b.US_DOE : b.DateOfExit,
              isdesc
            );
          case "EmployeeStatus":
            return compare(a.Type, b.Type, isdesc);
          default:
            return 0;
        }
      })
    );
    this.paginatorAll.pageSize = this.pageSize;
    this.dataSourceAll.paginator = this.paginatorAll;
  }

  onChangedPageSize(data: PageEvent) {
    this.paginatorAll.pageSize = data.pageSize;
    this.pageSize = data.pageSize;
    this.dataSourceAll.paginator = this.paginatorAll;
  }

  setPageSizeOptions(): number[] {
    this.pageSizeOpt = "";
    var data = [];
    for (var i = 0; i < this.dataSourceAll.data.length / 5; i++) {
      this.pageSizeOpt += 5 * (i + 1) + ",";
    }
    this.pageSizeOpt = this.pageSizeOpt.replace(/,\s*$/, "");
    this.pageSizeOptions = this.pageSizeOpt.split(",").map((str) => +str);
    return this.pageSizeOptions;
  }

  exportToExcelHR() {
    this.isLoader = true;
    this.datePipe = new DatePipe("en-US");
    var employees = [...this.dataSourceAll.data];

    this._service.getAllExcelEmployees(employees).subscribe(
      (data: Excelfile[]) => {
        this.excelDetails = data;
        if (this.excelDetails != null) {
          let { sheetName, fileName } = getFileName(name);

          var wb = xlsx.utils.book_new();
          var ws = xlsx.utils.json_to_sheet(this.excelDetails);
          xlsx.utils.book_append_sheet(wb, ws, sheetName);
          xlsx.writeFile(wb, `${fileName}.xlsx`);
        }
        this.isLoader = false;
      },
      (error) => {
        this.isLoader = false;
        this.error = error;
      }
    );
  }

  emptydate() {
    this.Date = null;
    this.filterRecords();
  }

  prepareResponse(dataList, key) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = { ...item, name: item[key], checked: true };
      finalRes.push(item);
    });
    return finalRes;
  }

  prepareUnSelectResponse(dataList, key) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = { ...item, name: item[key], checked: false };
      finalRes.push(item);
    });
    return finalRes;
  }

  prepareResponseCustom(dataList, key, selectedList) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = {
        ...item,
        name: item[key],
        checked: selectedList.includes(item.ID) ? true : false,
      };
      finalRes.push(item);
    });
    return finalRes;
  }

  getEeTypeList(): Promise<any> {
    return this.deptSvc
      .getMasterGroupByCategory("EeType")
      .toPromise()
      .then((data: any) => {
        this.deptSvc
          .getMasterGroupByGroupID(data[0].ID)
          .subscribe((dataList: any) => {
            const preparedFinalList = this.prepareResponse(dataList, "Value");
            this.eeTypeList = preparedFinalList || [];
          });
      });
  }

  getLocations(): Promise<any> {
    return this.onboardSvc
      .getLocations()
      .toPromise()
      .then((data: any) => {
        const preparedFinalList = this.prepareResponse(data, "LocationName");
        this.locationsList = preparedFinalList || [];
      });
  }

  getTeamList(): Promise<any> {
    return this.deptSvc
      .getMasterGroupByCategory("Team")
      .toPromise()
      .then((data: any) => {
        this.deptSvc
          .getMasterGroupByGroupID(data[0].ID)
          .subscribe((dataList: any[]) => {
            this.teamList = dataList;
            this.teamList = this.teamList.filter(
              (team) => team.Value != "Onshore"
            );
            const preparedFinalList = this.prepareResponse(
              this.teamList,
              "Value"
            );
            this.teamList = preparedFinalList || [];
          });
      });
  }

  getCadres(): Promise<any> {
    return this.onboardSvc
      .getCadres()
      .toPromise()
      .then((data: any) => {
        const preparedFinalList = this.prepareResponse(data, "CadreName");
        this.cadresList = preparedFinalList || [];
      });
  }

  getActiveFTEEmployees() {
    this.isLoader = true;
    this._service.getAllActiveFTEEmployees().subscribe(
      (data: EmployeeModel[]) => {
        this.dataSourceFTE.data = data;
        this.originalDataSourceFTE = data;
        this.dataSourceFTE.paginator = this.paginatorFTE;
        this.dataSourceFTE.sort = this.sortFTE;
        const dataToSort = [...this.dataSourceFTE.data];
        this.dataSourceFTE.data = dataToSort.sort((a, b) => {
          // Compare empcode values in descending order
          if (a.EmpCode > b.EmpCode) {
            return -1;
          } else if (a.EmpCode < b.EmpCode) {
            return 1;
          } else {
            return 0;
          }
        });
        this.isLoader = false;
      },
      (error) => {
        this.isLoader = false;
        this.error = error;
      }
    );
  }
  getActiveSubConEmployees() {
    this._service.getAllActiveSubConEmployees().subscribe(
      (data: EmployeeModel[]) => {
        this.dataSourceSubCon.data = data;
        this.originalDataSourceSubCon = data;
        this.dataSourceSubCon.paginator = this.paginatorSubCon;
        this.dataSourceSubCon.sort = this.sortSubCon;
        const dataToSort = [...this.dataSourceSubCon.data];
        this.dataSourceSubCon.data = dataToSort.sort((a, b) => {
          // Compare empcode values in descending order
          if (a.EmpCode > b.EmpCode) {
            return -1;
          } else if (a.EmpCode < b.EmpCode) {
            return 1;
          } else {
            return 0;
          }
        });
      },
      (error) => (this.error = error)
    );
  }
  tabClick(event) {
    const filterInputs = document.getElementsByTagName("input");
    for (let i = 0; i < filterInputs.length; i++) {
      const input = filterInputs[i];
      if (input.type === "text") {
        input.value = "";
      }
    }
    if (event.index == 0) {
      this.getAllEmployees();
    } else if (event.index == 1) {
      this.getActiveFTEEmployees();
    } else if (event.index == 2) {
      this.getActiveSubConEmployees();
    }
  }

  toggleAllSelection() {
    if (this.selectedAllStatus) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRecords();
  }

  toggleEmployeetype() {
    if (this.selectedAllEmpType) {
      this.empType.options.forEach((item: MatOption) => item.select());
    } else {
      this.empType.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRecords();
  }

  changeEmpType() {
    let newStatus = true;
    this.empType.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllEmpType = newStatus;
    this.filterRecords();
  }

  toggleLocation() {
    if (this.selectedAllLocations) {
      this.location.options.forEach((item: MatOption) => item.select());
    } else {
      this.location.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRecords();
  }

  changeLocation() {
    let newStatus = true;
    this.location.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllLocations = newStatus;
    this.filterRecords();
  }

  toggleGeo() {
    if (this.selectedAllGeo) {
      this.geo.options.forEach((item: MatOption) => item.select());
    } else {
      this.geo.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRecords();
  }

  changeGeo() {
    let newStatus = true;
    this.geo.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllGeo = newStatus;
    this.filterRecords();
  }

  toggleCadre() {
    if (this.selectedAllCadres) {
      this.cadre.options.forEach((item: MatOption) => item.select());
    } else {
      this.cadre.options.forEach((item: MatOption) => item.deselect());
    }
    this.filterRecords();
  }

  changeCadre() {
    let newStatus = true;
    this.cadre.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllCadres = newStatus;
    this.filterRecords();
  }

  changeStatus() {
    // let newStatus = true;
    // this.select.options.forEach((item: MatOption) => {
    //   if (!item.selected) {
    //     newStatus = false;
    //   }
    // });
    // this.selectedAllStatus = newStatus;
    this.filterRecords();
  }

  filterRecords() {
    let filteredData = this.filterData();
    this.dataSourceAll = new MatTableDataSource(this.sortList(filteredData));
    this.totalItems = this.dataSourceAll.data.length;
    this.dataSourceAll.paginator = this.paginatorAll;
  }

  filterData() {
    // this.isLoader = true;
    let data = [];
    data =
      this.originalDataSourceAll != null &&
      this.originalDataSourceAll.length > 0
        ? this.originalDataSourceAll
        : [];
    if (this.Date != null) {
      var minDate;
      var maxDate;
      var result = [];
      for (var i = 0; i < data.length; i++) {
        minDate = new Date(data[i].DOJ);
        maxDate =
          data[i].IsMigratedOnH1 == true
            ? data[i].US_DOE != null
              ? new Date(data[i].US_DOE)
              : null
            : data[i].DateOfExit != null
            ? new Date(data[i].DateOfExit)
            : null;
        var res = new Date(this.Date);
        if (maxDate == null && res >= minDate) {
          result.push(data[i]);
        }
        if (maxDate != null && res >= minDate && res <= maxDate)
          result.push(data[i]);
      }
      data = result;
    }
    if (
      this.statusResult != null &&
      this.statusResult != "" &&
      this.statusResult.length > 0
    ) {
      var result = [];
      const filteredResults = data.filter(
        (emp) =>
          emp.EmpStatus != null && this.statusResult.includes(emp.EmpStatus)
      );
      result = [...result, ...filteredResults];
      data = result;
    }
    if (
      this.empTypeResult != null &&
      this.empTypeResult != "" &&
      this.empTypeResult.length > 0
    ) {
      var result = [];
      const filteredResults = data.filter(
        (emp) =>
          emp.EeTypeId != null && this.empTypeResult.includes(emp.EeTypeId)
      );
      result = [...result, ...filteredResults];
      data = result;
    }
    if (
      this.locationResult != null &&
      this.locationResult != "" &&
      this.locationResult.length > 0
    ) {
      var result = [];
      const filteredResults = data.filter(
        (emp) =>
          emp.LocationID != null && this.locationResult.includes(emp.LocationID)
      );
      result = [...result, ...filteredResults];
      data = result;
    }
    if (
      this.geoResult != null &&
      this.geoResult != "" &&
      this.geoResult.length > 0
    ) {
      var result = [];
      const filteredResults = data.filter(
        (emp) => emp.TeamId != null && this.geoResult.includes(emp.TeamId)
      );
      result = [...result, ...filteredResults];
      data = result;
    }

    if (
      this.cadreResult != null &&
      this.cadreResult != "" &&
      this.cadreResult.length > 0
    ) {
      var result = [];
      const filteredResults = data.filter(
        (emp) => emp.CadreId != null && this.cadreResult.includes(emp.CadreId)
      );
      result = [...result, ...filteredResults];
      data = result;
    }
    if (this.search != null && this.search != "") {
      var result = [];
      result = data.filter(
        (res) =>
          (res.NamePerRecords != "" &&
            res.NamePerRecords != null &&
            this.removeExtraSpaces(res.NamePerRecords.toLowerCase()).includes(
              this.removeExtraSpaces(this.search.toLowerCase())
            )) ||
          res.EmpCode.toString().includes(this.search.toLowerCase())
      );
      data = result;
    }

    if (
      this.cadreResult == null ||
      this.cadreResult.length == 0 ||
      this.cadreResult.length < 1 ||
      this.geoResult == null ||
      this.geoResult.length == 0 ||
      this.geoResult.length < 1 ||
      this.locationResult == null ||
      this.locationResult.length == 0 ||
      this.locationResult.length < 0 ||
      this.empTypeResult == null ||
      this.empTypeResult.length == 0 ||
      this.empTypeResult.length < 0 ||
      this.statusResult == null ||
      this.statusResult.length == 0 ||
      this.statusResult.length < 0
    ) {
      data = [];
    }

    // setTimeout(() => {
    //   this.isLoader = false;
    // }, 1000);

    return data;
  }

  resetFilter() {
    this.Date = new Date();
    this.getEeTypeList()
      .then(() => this.getLocations())
      .then(() => this.getTeamList())
      .then(() => this.getCadres())
      .then(() => {
        this.initializeSelections();
      });
    this.search = null;
    this.filterRecords();
    this.dataSourceAll = new MatTableDataSource(
      this.sortList(this.originalDataSourceAll)
    );
    this.totalItems = this.dataSourceAll.data.length;
    this.dataSourceAll.paginator = this.paginatorAll;
  }

  AddEmp() {
    const dialogRef = this.dialog.open(GroupIdConfirmDialogComponent, {
      width: "400px",
      data: "hremployee",
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult.event) {
          if (dialogResult.type == "New") {
            this.router.navigate(["hremployeedetails"]);
          } else if (dialogResult.type == "Re-hire") {
            var details =
              this.employeeDetails != null && this.employeeDetails.length > 0
                ? this.employeeDetails.find((emp) => {
                    const isH1Migrated = emp.IsMigratedOnH1;
                    const isValidDateOfExit = isH1Migrated
                      ? emp.US_DOE != null
                      : emp.DateOfExit != null;
                    return (
                      emp.GroupId === dialogResult.groupId &&
                      new Date(emp.DOB).getTime() ===
                        new Date(dialogResult.dob).getTime() &&
                      emp.SecondaryEmail === dialogResult.secondaryEmail &&
                      isValidDateOfExit
                    );
                  })
                : undefined;
            if (details != undefined)
              this.router.navigate(["/hremployeedetails"], {
                queryParams: {
                  groupId: dialogResult.groupId,
                  dob: dialogResult.dob,
                  secondaryEmail: dialogResult.secondaryEmail,
                },
              });
          }
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
}
const getFileName = (name: string) => {
  let timeSpan = new Date().toISOString();
  let sheetName = name || "ExportResult";
  let fileName = `${sheetName}-${timeSpan}`;
  return {
    sheetName,
    fileName,
  };
};

function compare(a, b, isdesc) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a === b) return 0;

  if (isdesc) return a < b ? 1 : -1;
  else return a < b ? -1 : 1;
}
